import React, {Component} from "react";
import "./Recommendations.css";
import RecommendationCard from "../RecommendationCard"
import recommendationObjects from "../../utils/recommendationObjects.js";
// const createMarkup = require("../../utils/library.js").createMarkup;

class Recommendations extends Component {
	render(){
		return(
			<section id="referrals" className="section white center scrollspy">
				<h4 className="revealThis">Totally <strong className="indigo-text darken-4">Legit</strong> Referrals</h4>
				<div className="container">
					<div className="row revealThis">
						
						<div className="slick-carousel">
							{recommendationObjects.map((recommendation,index)=>{
								return(
									<RecommendationCard
										key={index}
										img={recommendation.img}
										recommendation={recommendation.recommendation}
										firstName={recommendation.firstName}
										nickName={recommendation.nickName}
										lastName={recommendation.lastName}
									/>
								)
							})}
						</div>

					</div>
				</div>
			</section>
		)
	}
}

export default Recommendations;


// WEBPACK FOOTER //
// ./src/components/Recommendations/Recommendations.js